var app = angular.module('tf.datePicker', [])

    .controller('datePickerCtrl', ['$scope', '$uibModalInstance', '$window', '$localStorage', function datePickerController($scope, $uibModalInstance, $window, $localStorage) {

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };



    }])


    ;
